// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AnchorButton_wrapper__eLpoh","image":"AnchorButton_image__Rm2K_"};